function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "id3"
}, /*#__PURE__*/React.createElement("path", {
  d: "m250 274.19h336v334.9h-336z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-250.32 -274.19)",
  clipPath: "url(#id3)"
}, /*#__PURE__*/React.createElement("path", {
  transform: "matrix(.14481 0 0 -.14479 145.64 749.38)",
  d: "m3005.1 2126c0-622.13-504.34-1126.4-1126.5-1126.4s-1126.5 504.32-1126.5 1126.4c0 622.16 504.32 1126.5 1126.5 1126.5s1126.5-504.34 1126.5-1126.5zm0 0",
  fill: "none",
  stroke: "#15122a",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 60
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m167.36 235.05c-37.379 0-67.688-30.305-67.688-67.676 0-37.379 30.309-67.68 67.688-67.68 37.387 0 67.688 30.301 67.688 67.68 0 37.371-30.301 67.676-67.688 67.676zm0-184.3c-64.418 0-116.64 52.215-116.64 116.62 0 64.402 52.219 116.62 116.64 116.62s116.64-52.215 116.64-116.62c0-64.41-52.219-116.62-116.64-116.62",
  fill: "#00a499"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#15122a",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 8.688
}, /*#__PURE__*/React.createElement("path", {
  d: "m167.36 235.05c-37.379 0-67.687-30.305-67.687-67.676 0-37.379 30.309-67.68 67.687-67.68 37.387 0 67.687 30.301 67.687 67.68 0 37.371-30.301 67.676-67.687 67.676zm0-184.3c-64.418 0-116.64 52.215-116.64 116.62 0 64.402 52.219 116.62 116.64 116.62s116.64-52.215 116.64-116.62c0-64.41-52.219-116.62-116.64-116.62z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m180.8 164.88h221.34"
}), /*#__PURE__*/React.createElement("path", {
  d: "m179.96 145.97-33.383 18.871 32.973 19.578z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m363.8 165.89 8.1953 26.719h-16.5l-8.1953-26.719z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m363.8 164.52 8.1953-26.715h-16.5l-8.1953 26.715z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m392.9 165.89 8.2031 26.719h-16.5l-8.2031-26.719z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m392.9 164.52 8.2031-26.715h-16.5l-8.2031 26.715z"
}));

function SvgIntroFormIcon4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 541.72,
    height: 446.09,
    viewBox: "0 0 406.49 334.82",
    zoomAndPan: "magnify",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroFormIcon4);
export default __webpack_public_path__ + "static/media/introFormIcon4.f687fe9d.svg";
export { ForwardRef as ReactComponent };